var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from '@angular/core';
// generator function
export function counter(from, to) {
    var i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                i = from;
                _a.label = 1;
            case 1:
                if (!(i <= to)) return [3 /*break*/, 4];
                return [4 /*yield*/, i];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
var PagerComponent = /** @class */ (function () {
    function PagerComponent() {
        this.visiblePagesCount = 10;
        this.pageSelect = new EventEmitter();
        this.currentViewIndex = 0;
        this.currentPage = 1;
    }
    Object.defineProperty(PagerComponent.prototype, "selectedPage", {
        set: function (page) {
            this._selectPage(page);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerComponent.prototype, "pages", {
        get: function () {
            return counter(this.firstVisiblePage, Math.min(this.lastVisiblePage, this.totalPages));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerComponent.prototype, "isFirstPage", {
        get: function () {
            return this.currentPage === 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerComponent.prototype, "isLastPage", {
        get: function () {
            return this.currentPage === this.totalPages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerComponent.prototype, "isLeftEllipsisVisible", {
        get: function () {
            return this.currentViewIndex > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerComponent.prototype, "isRightEllipsisVisible", {
        get: function () {
            return this.totalPages - this.lastVisiblePage > 0;
        },
        enumerable: true,
        configurable: true
    });
    PagerComponent.prototype.onPageClick = function (page) {
        if (this.currentPage !== page) {
            this.pageSelect.emit(page);
        }
    };
    PagerComponent.prototype.onNextPageClick = function () {
        if (!this.isLastPage) {
            this.pageSelect.emit(this.currentPage + 1);
        }
    };
    PagerComponent.prototype.onPreviousPageClick = function () {
        if (!this.isFirstPage) {
            this.pageSelect.emit(this.currentPage - 1);
        }
    };
    PagerComponent.prototype.toPreviousView = function () {
        this.pageSelect.emit(this.firstVisiblePage - 1);
    };
    PagerComponent.prototype.toNextView = function () {
        this.pageSelect.emit(this.lastVisiblePage + 1);
    };
    PagerComponent.prototype._selectPage = function (page) {
        this.currentPage = page;
        this.currentViewIndex = Math.floor((page - 1) / this.visiblePagesCount);
    };
    Object.defineProperty(PagerComponent.prototype, "lastVisiblePage", {
        get: function () {
            return (this.currentViewIndex + 1) * this.visiblePagesCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerComponent.prototype, "firstVisiblePage", {
        get: function () {
            return this.currentViewIndex * this.visiblePagesCount + 1;
        },
        enumerable: true,
        configurable: true
    });
    return PagerComponent;
}());
export { PagerComponent };
